import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage, getLanguages } from 'react-localize-redux';
import { numberFormat } from '../../helper/utils';

import './tooltip.styl';

class Tooltip extends PureComponent {
  getFormattedValue = val => numberFormat(+val, this.props.currentLanguage, 1);

  render() {
    const style = {
      display: this.props.visible ? 'block' : 'none',
      left: this.props.left,
      top: this.props.top - this.props.height - 15,
      width: this.props.width
    };

    return this.props.visible ? (
      <div className="tooltip" style={style}>
        <div className="tooltip__title">{this.props.layerTitle}</div>
        <div className="tooltip__label">{this.props.subTitle}</div>
        <div className="tooltip__entry">
          {this.context.getCountryLabel(this.props.countryLeft)}: <b>{this.getFormattedValue(this.props.countryLeft_val)} {this.props.translate('tooltip.percent')}</b>
        </div>
        <div className="tooltip__entry">
          {this.context.getCountryLabel(this.props.countryRight)}: <b>{this.getFormattedValue(this.props.countryRight_val)} {this.props.translate('tooltip.percent')}</b>
        </div>
      </div>) : null;
  }
}

Tooltip.contextTypes = {
  getCountryLabel: PropTypes.func
};

export default connect(
  state => ({
    currentLanguage: getActiveLanguage(state.locale).code,
    translate: getTranslate(state.locale),
    languages: getLanguages(state.locale)
  })
)(Tooltip);



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js